/* eslint-disable prettier/prettier */
import { authConstant } from "../constants/authConstants"
const initialState = {
    data: null,
    status: "idle",
    error: null
}

const login = (state = initialState, action) => {
    switch (action.type) {
        case authConstant.LOGIN_SUCCESS:
            return {
                data: action.payload,
                status: "success",
                error: null
            }
        case authConstant.LOGIN_FAILED:
            return {
                data: null,
                status: 'error',
                error: action.payload,
            }
        default:
            return state
    }
}

export default login;